import React, { useEffect, useState } from "react";
import useChatStore from "../store/useChatStore";
import { LuClock } from "react-icons/lu";
import { ticketRaisedAPI } from "../api-services/ticketraised.api";
import { API_URL } from "../api-services/Environment";

const TicketRised = () => {
  const { ticketRaisedInfo, currentScreen, setTicketRaisedInfo, inputValue } =
    useChatStore();
  const [expandedCard, setExpandedCard] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Function to toggle card expansion
  const toggleCard = (id) => {
    setExpandedCard(expandedCard === id ? null : id); // Toggle between expanded and collapsed
  };
  const tickets = Array.isArray(ticketRaisedInfo) ? ticketRaisedInfo : [];
  // Fetch ticket data when the screen is 'ticketrised'
  useEffect(() => {
    const fetchTickets = async () => {
      try {
        const params = { email: inputValue };
        if (currentScreen === "ticketrised") {
          setIsLoading(true);
          const response = await ticketRaisedAPI(params);
          if (response?.message !== "Un-Successful") {
            const ticketRaisedJson = await response.json();
            setTicketRaisedInfo(ticketRaisedJson?.payload?.result || []);
          }
        }
      } catch (error) {
        console.error("Error fetching tickets:", error);
      } finally {
        setIsLoading(false);
      }
    };
    setIsLoading(true);
    fetchTickets();
  }, [currentScreen, inputValue, setTicketRaisedInfo]);

  return (
    <div className="card-wrapper">
      {isLoading && (
        <div className="loader-overlay">
          <img
            src={`${API_URL}common/gif/loader.gif.gif`}
            alt="loader"
            style={{ width: 80, height: 80 }}
          />
        </div>
      )}
      {!isLoading && tickets?.length > 0
        ? tickets?.map((val, index) => (
            <div className="main-container" key={index}>
              <div className="card-container">
                <div className="card-header">
                  <span className="card-id">ID #{val?.ticketId}</span>
                  {val?.status === "Assigned" ? (
                    <LuClock color={"#006BEA"} size={14} />
                  ) : (
                    <span
                      className={`card-status ${
                        val?.status === "Pending"
                          ? "pending"
                          : val?.status === "Resolved"
                            ? "resolved"
                            : val?.status === "Reopened"
                              ? "reopened"
                              : ""
                      }`}
                    >
                      {val?.status}
                    </span>
                  )}
                </div>

                <div className="card-body">
                  <div>
                    <img
                      src={val?.product?.productImage}
                      alt="Product"
                      className="card-image"
                    />
                  </div>

                  <div
                    className="card-content"
                    style={{ position: "relative" }}
                  >
                    <h3 className="card-title">{val?.product?.name}</h3>
                    {/* Text content with accordion functionality */}
                    <p
                      className={`card-description ${
                        expandedCard === index ? "expanded" : "collapsed"
                      }`}
                    >
                      {val?.title}
                    </p>
                    {val?.title?.length > 75 && (
                      <button
                        className="accordion-toggle"
                        onClick={() => toggleCard(index)}
                      >
                        {expandedCard === index ? (
                          <span style={{ fontSize: "13px" }}>See less</span>
                        ) : (
                          <span style={{ fontSize: "13px" }}>See more</span>
                        )}
                      </button>
                    )}
                    <div className="semi-curved-div"></div>
                  </div>
                </div>
              </div>
              <div className="card-time">
                <span>
                  {new Date(val?.createdAt).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </span>
                <span className="time-dot">•</span>
                <span>
                  {new Date(val?.createdAt).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
              </div>
            </div>
          ))
        : !isLoading &&
          tickets.length === 0 && (
            <div className="no-order-div">No Tickets Found</div>
          )}
    </div>
  );
};

export default TicketRised;
